"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsupportedMediaTypeError = void 0;
class UnsupportedMediaTypeError extends Error {
    constructor(message) {
        super(message);
        this.className = "UnsupportedMediaTypeError";
        this.message = "";
        this.message = message;
    }
}
exports.UnsupportedMediaTypeError = UnsupportedMediaTypeError;
//# sourceMappingURL=UnsupportedMediaTypeError.js.map